export enum SubscriptionTierEnum {
    Basic = 1,
    Business = 2,
    Premium = 3,
    Custom = 4,
    Free = 5,
    Starter = 6,
    Custom_Slider = 7
}